import { useSpring } from "@react-spring/core";
import { animated } from "@react-spring/web";
import { useRef, useState, useEffect } from "react";
import useKeyPress from "../modules/useKeyPress";
import useStore from "../modules/useStore";
import SplitTitle from "./SplitTitle";
import ProjectControls from "./ProjectControls";

export default function ProjectStats() {
  const leftPressed = useKeyPress("ArrowLeft");
  const rightPressed = useKeyPress("ArrowRight");
  const ref = useRef();
  const { projects, currentProject, nextProject, prevProject } = useStore(
    ({ projects, currentProject, nextProject, prevProject }) => ({
      projects,
      currentProject,
      nextProject,
      prevProject,
    })
  );
  const [progress, setProgress] = useState(0);
  const [width, setWidth] = useState(0);
  const { x } = useSpring({
    from: { x: 0 },
    x: progress,
  });
  useEffect(() => {
    if (ref.current) {
      const length = ref.current.offsetWidth / projects.length;
      const progress = currentProject * length;
      setProgress(progress);
      setWidth(length);
    }
  }, [currentProject, ref]);

  useEffect(() => {
    if (leftPressed) prevProject();
    if (rightPressed) nextProject();
  }, [leftPressed, rightPressed]);

  const project = projects[currentProject];

  return (
    <div className="fixed top-0 left-0 z-10 w-screen h-screen flex flex-col justify-between items-center p-4 md:p-10 pointer-events-none">
      <div
        ref={ref}
        className="progress h-0.5 bg-white bg-opacity-20 w-1/2 my-4"
      >
        <animated.div
          style={{ x, width }}
          className="indicator h-full bg-gray-200"
        />
      </div>
      <div className="current-project flex flex-col-reverse justify-between items-start w-full">
        <div className="text-container overflow-hidden font-bold relative flex-grow py-2 px-10 left-0" style={{perspective: '200px'}}>
          <div className="opacity-0 text-4xl md:text-6xl xl:text-8xl">Filliuagsdiusadoasdoiuasdhd</div>
          {projects.map((p, i) => (
            <SplitTitle
              title={[...p.title]}
              willShow={currentProject <= i}
              visible={currentProject == i}
              key={p.title}
            />
          ))}
        </div>
        <div className="about w-1/4 text-white my-20" style={{minWidth: '300px'}}>
          <p className="font-medium text-sm leading-relaxed">
            {project.description}
          </p>
          {project.link && <a className="px-8 py-2 inline-block border-2 rounded-xl mt-10 pointer-events-auto bg-transparent text-white font-medium hover:opacity-50 transition duration-500" target="_blank" href={ project.link }>Explore</a> }
        </div>
      </div>
      <ProjectControls onNext={nextProject} onPrev={prevProject} />
    </div>
  );
}
